// import foo from './foo/fooSlice';

const root = {
	//	foo
};

export default root;
